// Almacén de trust tokens del dispositivo (design/CARD-LOGIN-2FA.md).
// No son de una sesión: sobreviven al logout, y el servidor solo acepta el
// que pertenezca a la cuenta resuelta. Máx. 10 enviados por petición.
const KEY = 'sgc-trust-tokens';
const MAX_SENT = 10;

export function getTrustTokens() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((t) => typeof t === 'string' && t) : [];
  } catch {
    return [];
  }
}

export function getTrustTokensToSend() {
  return getTrustTokens().slice(0, MAX_SENT);
}

// El servidor guarda hasta 20; el cliente no necesita cargar más de los que
// puede enviar en una petición, así que se recorta también al guardar.
export function saveTrustToken(token) {
  if (!token) return;
  const arr = getTrustTokens().filter((t) => t !== token);
  arr.unshift(token);
  localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX_SENT)));
}

export function clearTrustTokens() {
  localStorage.removeItem(KEY);
}
